import { gql } from 'apollo-angular';

export const unreadMessagesCount = gql`
  fragment unreadMessagesCount on Patient {
    unreadMessagesCount
  }
`;
